export const types = {
    ADDREQUEST: 'ADD-REQUEST',
    UPDATEREQUEST: 'UPDATE-REQUEST',
    VIEWREQUEST: 'VIEW-REQUEST',
    VIEWALLREQUESTS: 'VIEW-ALL-REQUEST',
    CLOSEREQUEST: 'CLOSE-REQUEST',
    LINKREQUESTS:'LINK-REQUESTS',
    UNLINKREQUESTS:'UN-LINK-REQUESTS',
    GETALLLINKREQUESTS:'GET-ALL-LINKED-REQUESTS',
    ADDRESOLUTION:'ADD-RESOLUTION',
    GETRESOLUTION:'GET-RESOLUTION',
    ASSOCIATEPROBLEM:'ASSOCIATE-REQUEST-WITH-PROBLEM',
    GETASSOCIATEDPROBLEMS:'GET-ASSOCIATED-PROBLEMS',
    ADDCHANGE:'ADD-CHANGE',
    VIEWCHANGE:'VIEW-CHANGE',
    UPDATECHANGE:'UPDATE-CHANGE',
    VIEWALLCHANGES:'VIEW-ALL-CHANGE',
    CLOSECHANGE:'CLOSE-CHANGE',
    DELETEREQUEST:'DELETE-REQUEST',
    ASSIGNCHANGE: 'ASSIGN-CHANGE',
    DELETECHANGE: 'DELETE-CHANGE',
    UPDATEPROJECT: 'UPDATE-PROJECT',
    ADDPROJECT: 'ADD-PROJECT',
    VIEWPROJECT: 'VIEW-PROJECT',
    VIEWALLPROJECT: 'VIEW-ALL-PROJECT',
    DELETEPROJECT: 'DELETE-PROJECT',
    GETALLCI: 'GET-ALL-CI',
    GETALLCICOUNT: 'GET-ALL-CI-COUNT',
    GETALLASSETS: 'GET-ALL-ASSETS',
    GETALLWORKSTATIONS: 'GET-ALL-WORKSTATION',
    ADDCI: 'ADD-CI',
    UPDATECI: 'UPDATE-CI',
    DELETECI: 'DELETE-CI',
    ADDUSER: 'ADD-USER',
    UPDATEUSER: 'UPDATE-USER',
    GETUSER: 'GET-USER',
    GETALLUSERS: 'GET-ALL-USERS',
    DELETEUSER: 'DELETE-USER',
    CHANGEASTECHNICIAN: 'CHANGE-AS-TECHNICIAN',
    ADDTECHNICIAN: 'ADDTECHNICIAN',
    GETTECHNICIAN: 'GET-TECHNICIAN',
    GETALLTECHNICIAN: 'GET-ALL-TECHNICIAN',
    DELETETECHNICIAN: 'DELETE-TECHNICIAN',
    CHANGEASUSER: 'CHANGE-AS-USER',
    UPDATETECHNICIAN: 'UPDATE-TECHNICIAN'



};